import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatListModule } from '@angular/material/list';

@Component({
  selector: 'app-account-menu-sheet',
  standalone: true,
  imports: [
    MatListModule,
  ],
  templateUrl: './account-menu-sheet.component.html',
})
export class AccountMenuSheetComponent implements OnInit {
  data = inject(MAT_BOTTOM_SHEET_DATA);
  private _bottomSheetRef = inject<MatBottomSheetRef<AccountMenuSheetComponent>>(MatBottomSheetRef);
  private _router = inject(Router);

  
  public isParentExperience: boolean;
  public appCallOutEnabled = false;
  public appCallOutTitle: string;
  public showAppCallOut = false;

  constructor() {
    const data = this.data;

    this.appCallOutEnabled = data.appCallOutEnabled;
    this.appCallOutTitle = data.appCallOutTitle;
    this.isParentExperience = data.isParentExperience;
  }

  public ngOnInit(): void {
    this.setShowAppCallOut();
  }

  public setShowAppCallOut() {
    this.showAppCallOut = this.appCallOutEnabled && !this.isParentExperience;
  }

  public support() {
    this.data.support();
    this.closeSheet();
  }

  public signOut() {
    this.data.signOut();
    this.closeSheet();
  }

  public navigate(path: string) {
    this.closeSheet();
    this._router.navigate([path]);
  }

  public openAppCallOut() {
    this.data.openAppCallOut();
    this.closeSheet();
  }

  public closeSheet() {
    this._bottomSheetRef.dismiss();
  }
}
